import { Element, useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useSelector } from "react-redux";
import type { Vendor } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import SyncedBoothsSettings from "@/components/editor/shared/expo/booths-settings/synced-booths-settings-component";
import { getAllVendors } from "@/features/vendors/vendors-reducer";

import BoothCard from "../booth-card/booth-card-component";
import BoothsList from "./booths-list-component";

export const BOOTHS_LIST_ID = "booths-list";

type SyncedBoothsProps = {
  vendors?: Vendor[];
};

export default function SyncedBooths(props: SyncedBoothsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();
  const dasboardVendors = useSelector(getAllVendors);
  const vendors = props.vendors ?? dasboardVendors;

  const isEmpty = vendors.length === 0;
  const { enabled } = useEditor((state) => ({
    enabled: state.isEnabled(),
  }));

  if (!enabled && isEmpty) return null;

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <div className="flex justify-center">
            <Element
              id="title"
              is={Text}
              text="Expo Booths"
              pattern="headingTwo"
            />
          </div>
          <BoothsList id={BOOTHS_LIST_ID}>
            {enabled && isEmpty && <SyncedBoothsSettings minimal />}
            {vendors.map((vendor) => (
              <BoothCard key={vendor.id} vendor={vendor} />
            ))}
          </BoothsList>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

SyncedBooths.craft = {
  isCanvas: true,
  custom: {
    displayName: "Synced Expo Booths",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SyncedBoothsSettings,
  },
};
